export class UserSession {
  constructor(
    readonly sessionStartDate: string,
    readonly isOnline: boolean,
  ) {}
}
